module.exports = __webpack_public_path__ + "static/media/Img_9.4d34275e.JPG";